var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useCallback, useRef } from 'react';
import { useVirtual } from 'react-virtual';
import styled from 'styled-components';
import useThemeBreakpoints from '../../../../../hooks/useThemeBreakpoints';
import { VirtualizedList, VirtualizedListContainer, VirtualizedRowContainer, } from '../../../../../styled/Virtualized';
import MenuListWrapper from './MenuListWrapper';
import PopoverContent from './PopoverContent';
import { SelectAllOption } from './SelectAllOption';
var VirtualizedMenuList = function (themeFamily) { return function (props) {
    var _a;
    var listContainerRef = useRef();
    var options = props.options, children = props.children, isMulti = props.isMulti;
    var optionItems = React.Children.toArray(children);
    var maxHeight = useThemeBreakpoints({ component: 'dropdownMenu' }).height;
    var height = useThemeBreakpoints({ component: 'dropdownOption' }).height;
    var menuListMaxHeight = parseInt(maxHeight);
    var optionHeight = parseInt(height);
    var maxVisibleOptions = menuListMaxHeight / optionHeight;
    var optionsAmount = isMulti ? optionItems.length + 1 : optionItems.length;
    var listHeight = optionsAmount > maxVisibleOptions ? menuListMaxHeight : optionsAmount * optionHeight + 10;
    var isGroupedOptions = optionsAmount && ((_a = options[0]) === null || _a === void 0 ? void 0 : _a.options);
    var rowVirtualizer = useVirtual({
        size: optionsAmount,
        parentRef: listContainerRef,
        estimateSize: useCallback(function () { return optionHeight; }, []),
    });
    return (_jsxs(MenuListWrapper, __assign({ themeFamily: themeFamily }, props, { children: [!optionsAmount || isGroupedOptions ? (_jsxs(_Fragment, { children: [children, _jsx(PopoverContent, __assign({}, props), void 0)] }, void 0)) : (_jsx(VirtualizedListContainer, __assign({ ref: listContainerRef, height: listHeight }, { children: _jsx(VirtualizedList, __assign({ totalHeight: rowVirtualizer.totalSize }, { children: rowVirtualizer.virtualItems.map(function (virtualRow) {
                        var index = virtualRow.index, size = virtualRow.size, start = virtualRow.start;
                        if (isMulti && index === 0) {
                            return (_jsx(StyledVirtualizedRowContainer, __assign({ rowSize: size, rowStartY: start }, { children: _jsx(SelectAllOption, __assign({}, props, { innerRef: null }), void 0) }), index));
                        }
                        return (_jsx(StyledVirtualizedRowContainer, __assign({ rowSize: size, rowStartY: start }, { children: optionItems[isMulti ? index - 1 : index] }), index));
                    }) }), void 0) }), void 0)),
            _jsx(PopoverContent, __assign({}, props), void 0)] }), void 0));
}; };
export default VirtualizedMenuList;
var StyledVirtualizedRowContainer = styled(VirtualizedRowContainer)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  white-space: nowrap;\n  padding: 0 12px;\n  box-sizing: border-box;\n"], ["\n  white-space: nowrap;\n  padding: 0 12px;\n  box-sizing: border-box;\n"])));
var templateObject_1;
